// main tools
import { useContext } from 'react'

// context
import { PrimeReactContext } from 'primereact/api'

export const usePrimereact = () => useContext(PrimeReactContext)
